(function () {
/*
  * -----------------------------------------------------------------------------
  * @cam/quantity-pack-units
  * -----------------------------------------------------------------------------
  * @version 0.0.6
  * @overview Unit quantity to pack quantity input converter.
  * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
  * -----------------------------------------------------------------------------
*/ if (customElements.get("quantity-pack-units") === undefined) {
    class QuantityPackUnits extends HTMLElement {
        constructor(){
            super();
            this.packUnits = Number(this.attributes["data-pack-units"]?.value);
            this.unitsMaster = this.querySelector('input[name="quantity-pack-units-master"]');
            this.unitsQuantity = this.querySelector('input[name="quantity-pack-units-quantity"]');
            if (!this.packUnits || !this.unitsMaster || !this.unitsQuantity) return;
            this.unitsQuantity.addEventListener("change", this.adjustQuantity.bind(this));
            this.unitsMaster.addEventListener("change", this.dispatchNewEvent.bind(this));
        }
        adjustQuantity(event) {
            let unitValue = Math.ceil(event.target.valueAsNumber / this.packUnits);
            this.unitsMaster.value = unitValue;
            this.unitsMaster.dispatchEvent(new Event("change"));
        }
        dispatchNewEvent(event) {
            let quantity = Number(event.target.value);
            if (!quantity) return;
            this.dispatchEvent(new CustomEvent("updated", {
                detail: {
                    quantity: quantity
                }
            }));
        }
    }
    customElements.define("quantity-pack-units", QuantityPackUnits);
}



})();
